/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDriver200Response
 */
export interface CreateDriver200Response {
    /**
     * ドライバーコード
     * @type {string}
     * @memberof CreateDriver200Response
     */
    driverCode: string;
}

/**
 * Check if a given object implements the CreateDriver200Response interface.
 */
export function instanceOfCreateDriver200Response(value: object): value is CreateDriver200Response {
    if (!('driverCode' in value) || value['driverCode'] === undefined) return false;
    return true;
}

export function CreateDriver200ResponseFromJSON(json: any): CreateDriver200Response {
    return CreateDriver200ResponseFromJSONTyped(json, false);
}

export function CreateDriver200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDriver200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'driverCode': json['driver_code'],
    };
}

export function CreateDriver200ResponseToJSON(json: any): CreateDriver200Response {
    return CreateDriver200ResponseToJSONTyped(json, false);
}

export function CreateDriver200ResponseToJSONTyped(value?: CreateDriver200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'driver_code': value['driverCode'],
    };
}

